<template>
<div>
  <template v-if="type == 'Car'">
      <ReservationCar></ReservationCar>
  </template>
  <template v-if="type == 'Dive'">
      <ReservationScuba />
  </template>
  <template v-if="type == 'Scooter'">
      <ReservationScooter />
  </template>
  <template v-if="type == 'Eco Wheels'">
      <ReservationEcoWheels />
  </template>
  </div>
</template>

<script>
import ReservationScooter from "./ReservationScooter.vue";
import ReservationScuba from "./ReservationScuba.vue";
import ReservationEcoWheels from "./ReservationEcoWheels.vue";
import ReservationCar from "./ReservationCar.vue";
import { mapGetters } from 'vuex'

export default {
  name: "Reservation",
  components: {
    ReservationScooter,
    ReservationScuba,
    ReservationEcoWheels,
    ReservationCar
  },
  mounted() {
    this.$store.dispatch('setType')
    this.$store.dispatch('setBookNowUrl')
  },
  computed: {
    ...mapGetters([
      'type',
      'bookNowUrl'
    ])
  }
}
</script>

<style>

</style>